import { Owner, OwnerOwnerCategoryEnum } from 'api'
import React, { ReactElement } from 'react'

interface ShareholderActionsProps {
  editShareholder?: (shareholder: Owner) => void
  addShareholderToOwner?: (shareholder: Owner) => void
  shareholder: Owner
}

export const ShareholderActions = ({
  editShareholder,
  addShareholderToOwner,
  shareholder,
}: ShareholderActionsProps): ReactElement => {
  return (
    <span className="flex justify-content-end ml-2">
      {editShareholder && (
        <button
          title="Edit"
          aria-label="Edit"
          className="btn btn-link p-0 mr-2"
          onClick={() => editShareholder(shareholder)}
        >
          <i className="mdi mdi-pencil" />
        </button>
      )}
      {addShareholderToOwner && shareholder.ownerCategory === OwnerOwnerCategoryEnum.Entity && (
        <button
          title="Add Sub-Shareholder"
          aria-label="Add Sub-Shareholder"
          className="btn btn-link p-0 mr-2"
          onClick={() => addShareholderToOwner(shareholder)}
        >
          <i className="mdi mdi-plus" />
        </button>
      )}
    </span>
  )
}
